import { ref } from 'vue'

/**
 * [CCTOWER-3605] 文字运价识别 — 助手联动信号
 *
 * 供「运价维护」等页面的【AI解析 → 文字运价解析】入口调用：
 * 调用 openTextRateAssistant() 后，
 * - HeaderNav 监听信号 → 自动打开控制塔智能助手弹窗（含助手被隐藏时自动恢复）
 * - AiChatPanel 监听信号 → 自动切到【文字运价识别】标签并进入引导模式
 *
 * 实现仿 wobaoState.chatExpandSignal 的模块级单例递增信号模式。
 */
const openTextRateSignal = ref(0)

export function useTextRateAssistant() {
  /** 请求打开助手并激活【文字运价识别】标签 */
  const openTextRateAssistant = () => {
    openTextRateSignal.value++
    if (typeof window !== 'undefined') {
      (window as any).__pendingOpenTextRate = true
      window.dispatchEvent(new CustomEvent('open-text-rate-assistant'))
    }
  }

  return { openTextRateSignal, openTextRateAssistant }
}
